// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file voucher/types/v1/membership.proto (package voucher.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Discount, UsageRestriction } from "./usage_pb.js";
import { LocalTime } from "../../../types/v1/localtime_pb.js";

/**
 * @generated from enum voucher.types.v1.Association
 */
export const Association = /*@__PURE__*/ proto3.makeEnum(
  "voucher.types.v1.Association",
  [
    {no: 0, name: "ASSOCIATION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ASSOCIATION_ADAC", localName: "ADAC"},
  ],
);

/**
 * @generated from message voucher.types.v1.BenefitOverview
 */
export const BenefitOverview = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.BenefitOverview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "associations", kind: "enum", T: proto3.getEnumType(Association), repeated: true },
    { no: 4, name: "discount", kind: "message", T: Discount },
    { no: 5, name: "start", kind: "message", T: LocalTime, opt: true },
    { no: 6, name: "end", kind: "message", T: LocalTime, opt: true },
    { no: 7, name: "max_usage", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "current_usage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message voucher.types.v1.Benefit
 */
export const Benefit = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.Benefit",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "associations", kind: "enum", T: proto3.getEnumType(Association), repeated: true },
    { no: 5, name: "discount", kind: "message", T: Discount },
    { no: 6, name: "usage_restriction", kind: "message", T: UsageRestriction, opt: true },
    { no: 7, name: "start", kind: "message", T: LocalTime, opt: true },
    { no: 8, name: "end", kind: "message", T: LocalTime, opt: true },
    { no: 9, name: "event_series_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "price_group_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "price_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "bundle_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message voucher.types.v1.ActiveBenefit
 */
export const ActiveBenefit = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.ActiveBenefit",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "associations", kind: "enum", T: proto3.getEnumType(Association), repeated: true },
    { no: 3, name: "discount", kind: "message", T: Discount },
    { no: 4, name: "event_series_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "price_group_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "price_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "bundle_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

